// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QSLW","content":"styles_content__3QZW7","row":"styles_row__1unh5","footer":"styles_footer__2oVO2","phraseLength":"styles_phraseLength__3Ov1k"};